import { MAX_TEXT_OPTION_LOOKUP_IDS } from '@repo/api-contracts';
import { trpc } from '@/shared/api';

/**
 * id 로 잉크 이름·색상 코드 찾기(productManagement.inkColors.listByIds, 결정 D12) — useFontsByIdsQuery 와 대칭.
 * 지운 잉크도 deleted 로 돌려준다. id 가 없으면 묻지 않고, 계약 상한을 넘는 id 는 앞부분만 묻는다.
 */
export const useInkColorsByIdsQuery = (ids: readonly string[]) => {
  const lookupIds = ids.slice(0, MAX_TEXT_OPTION_LOOKUP_IDS);
  return trpc.productManagement.inkColors.listByIds.useQuery(
    { ids: lookupIds },
    { enabled: lookupIds.length > 0 },
  );
};
